export default "__VITE_ASSET__Cng$s90d__"